export const candidatesKeys = {
  all: ["candidates"] as const,
  list: () => [...candidatesKeys.all, "list"] as const,
  detail: (slug: string) => [...candidatesKeys.all, "detail", slug] as const,
};
